"use client";

import { useEffect } from "react";
import Image from "next/image";

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="relative min-h-[100dvh] flex flex-col text-center px-6 py-[120px] overflow-hidden">
      <div className="flex flex-col items-center gap-10 z-10">
        <div className="relative w-full md:w-[350px] aspect-square">
          <Image
            src="/images/graphic-robot.png"
            alt="We couldn't get the results just yet"
            fill
            sizes="700px"
          />
        </div>
        <div className="flex flex-col gap-5 justify-center items-center">
          <div className="flex flex-col gap-2 justify-center items-center">
            <h2 className="text-[28px] font-medium text-[#1F2937] text-center leading-[1.4]">
              Something went wrong!
            </h2>
            <p className="text-base text-gray-500 text-center leading-[1.4]">
              We're sorry, but something went wrong. Please reload the page or contact support for
              assistance.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
